import React from 'react';
import { CheckCircle } from 'lucide-react';

const VerificationComplete = ({ onCancel, onTimeout, amount, config }) => (
  <div className={`bg-white text-gray-800 h-full flex flex-col items-center justify-center p-3 ${config.ui.maxWidth} mx-auto`}>
    <CheckCircle className="w-16 h-16 text-green-600 mb-4" />
    <div className="text-2xl font-bold text-green-600 mb-4">Transaction Approved</div>
    <div className="bg-gray-100 p-4 rounded-xl mb-6 w-full">
      <div className="space-y-2 text-sm">
        <div className="flex justify-between">
          <span>Amount:</span>
          <span className="font-bold">${amount || '0.00'}</span>
        </div>
        <div className="flex justify-between">
          <span>Card:</span>
          <span>****1234</span>
        </div>
        <div className="flex justify-between">
          <span>Approval:</span>
          <span>123456</span>
        </div>
      </div>
    </div>
    <div className="flex space-x-3">
      <button 
        onClick={onCancel}
        className="px-4 py-2 bg-red-600 text-white font-bold rounded-lg hover:bg-red-700 transition-colors text-sm"
      >
        CANCEL
      </button>
      <button 
        onClick={onTimeout}
        className="px-4 py-2 bg-blue-600 text-white font-bold rounded-lg hover:bg-blue-700 transition-colors text-sm"
      >
        CONTINUE
      </button>
    </div>
  </div>
);

export default VerificationComplete;